export default "__VITE_ASSET__BHtn6oI0__"